import { t } from '@/shared/lib/i18n'

export interface SignerStatus {
  userId: number
  userName: string
  sortOrder: number
  signed: boolean
}

const SignersChain = ({ signers }: { signers: SignerStatus[] }) => (
  <div className="space-y-1">
    <p className="text-xs font-medium text-muted-foreground">
      {t('reports.signatures.chainStatus')}
    </p>
    <ol className="space-y-0.5">
      {signers.map((s) => (
        <li key={s.userId} className="flex items-center gap-2 text-sm">
          <span className={s.signed ? 'text-green-600 font-medium' : 'text-muted-foreground'}>
            {s.sortOrder}. {s.userName}
          </span>
          {s.signed && <span className="text-xs text-green-600">✓</span>}
        </li>
      ))}
    </ol>
  </div>
)

export default SignersChain
